import {
  SEAT_BOOKING_GET_DATA,
  SEAT_BOOKING_DATA,
  SEAT_BOOKING_ADD_DATA,
  SEAT_BOOKING_CANCEL_DATA,
  MY_BOOKING_GET_DATA,
  SEAT_BOOKING_TIMESLOT_DATA,
} from "./Constants";

/* ================= AVAILABLE SEATS ================= */
const loadSeatBookingGetDataRequest = (params) => ({
  type: SEAT_BOOKING_GET_DATA.SEAT_BOOKING_GET_DATA_LOAD,
  params,
});

const setSeatBookingGetDataSuccess = (avaibleseats) => ({
  type: SEAT_BOOKING_GET_DATA.SEAT_BOOKING_GET_DATA_SUCCESS,
  avaibleseats,
});

const setSeatBookingGetDataFail = (error) => ({
  type: SEAT_BOOKING_GET_DATA.SEAT_BOOKING_GET_DATA_FAIL,
  error,
});

/* ================= FLOOR PLAN LISTING ================= */
const loadSeatBookingDataRequest = () => ({
  type: SEAT_BOOKING_DATA.SEAT_BOOKING_DATA_LOAD,
});

const setSeatBookingDataSuccess = (seats) => ({
  type: SEAT_BOOKING_DATA.SEAT_BOOKING_DATA_SUCCESS,
  seats,
});

const setSeatBookingDataFail = (error) => ({
  type: SEAT_BOOKING_DATA.SEAT_BOOKING_DATA_FAIL,
  error,
});

/* ================= RESERVE SEAT (POST) ================= */
const loadSeatBookingAddDataRequest = (payload) => ({
  type: SEAT_BOOKING_ADD_DATA.SEAT_BOOKING_ADD_DATA_LOAD,
  payload,
});

const setSeatBookingAddDataSuccess = (data) => ({
  type: SEAT_BOOKING_ADD_DATA.SEAT_BOOKING_ADD_DATA_SUCCESS,
  data,
});

const setSeatBookingAddDataFail = (error) => ({
  type: SEAT_BOOKING_ADD_DATA.SEAT_BOOKING_ADD_DATA_FAIL,
  error,
});

/* ================= CANCEL SEAT (PUT) ================= */
const loadSeatBookingCancelDataRequest = (reservation_id) => ({
  type: SEAT_BOOKING_CANCEL_DATA.SEAT_BOOKING_CANCEL_DATA_LOAD,
  reservation_id,
});

const setSeatBookingCancelDataSuccess = (data) => ({
  type: SEAT_BOOKING_CANCEL_DATA.SEAT_BOOKING_CANCEL_DATA_SUCCESS,
  data,
});

const setSeatBookingCancelDataFail = (error) => ({
  type: SEAT_BOOKING_CANCEL_DATA.SEAT_BOOKING_CANCEL_DATA_FAIL,
  error,
});

/* ================= MY SEATS ================= */
const loadMyBookingGetDataRequest = () => ({
  type: MY_BOOKING_GET_DATA.MY_BOOKING_GET_DATA_LOAD,  
});

const setMyBookingGetDataSuccess = (mybookings) => ({
  type: MY_BOOKING_GET_DATA.MY_BOOKING_GET_DATA_SUCCESS,
  mybookings,
});

const setMyBookingGetDataFail = (error) => ({
  type: MY_BOOKING_GET_DATA.MY_BOOKING_GET_DATA_FAIL,
  error,
});
/* ================= TIME SLOT LISTING ================= */
const loadSeatBookingTimeSlotDataRequest = () => ({
  type: SEAT_BOOKING_TIMESLOT_DATA.SEAT_BOOKING_TIMESLOT_DATA_LOAD,
});

const setSeatBookingTimeSlotDataSuccess = (slots) => ({
  type: SEAT_BOOKING_TIMESLOT_DATA.SEAT_BOOKING_TIMESLOT_DATA_SUCCESS,
  slots,
});

const setSeatBookingTimeSlotDataFail = (error) => ({
  type: SEAT_BOOKING_TIMESLOT_DATA.SEAT_BOOKING_TIMESLOT_DATA_FAIL,
  error,
});
export {
  
  loadSeatBookingGetDataRequest,setSeatBookingGetDataSuccess,setSeatBookingGetDataFail,
  loadSeatBookingDataRequest,setSeatBookingDataSuccess,setSeatBookingDataFail,  
  loadSeatBookingAddDataRequest,setSeatBookingAddDataSuccess,setSeatBookingAddDataFail,
  loadSeatBookingCancelDataRequest,setSeatBookingCancelDataSuccess,setSeatBookingCancelDataFail,
  loadMyBookingGetDataRequest, setMyBookingGetDataSuccess, setMyBookingGetDataFail,
  loadSeatBookingTimeSlotDataRequest, setSeatBookingTimeSlotDataSuccess,setSeatBookingTimeSlotDataFail,
};
